import React from 'react';
import { connect } from "react-redux";
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { ClickButton } from '../../base/buttons';
import { AbstractDialog } from "../../base/dialog";
import { translate } from "../../base/i18n";
import { getLocalParticipant } from "../../base/participants";
import { addMessage, resetSendFileList, sendMessage } from "../actions";
import { OK_FILE } from "../constants";
import { getDownLoadLink, getPrivateMessageRecipient, isSendFileMessageValid } from "../functions";

function SendFileCheckPopup({
    t, dispatch, recipient, sendfileList, local, handlerHideModal
}) {
    const sendFile = async() => {        
        const successFile = sendfileList.get(OK_FILE);
        if (successFile) {
            for (let i in successFile) {
                const file = successFile[i];

                if (isSendFileMessageValid(file)) {
                    const { name, size } = file;
                    let formData = new FormData();
                    formData.append("file", file, name);

                    let sendData = {
                        type: "file",
                        content: {name, size, downloadLink: null},
                        uuid: uuidv4(),
                        recipient,
                        displayName: local.nickname
                    };

                    // 미리 전송 
                    dispatch(addMessage({
                        isMe: true,
                        hasRead: true, 
                        from: local.user_uuid,
                        message: JSON.stringify(sendData),
                        privateMessage: false,
                        timestamp: new Date().getTime()
                    }));
                    handlerSendFile(sendData);

                    const downloadLink = await getDownLoadLink(formData);            
                    if (downloadLink) {
                        sendData.content.downloadLink = downloadLink;
                        
                        handlerSendFile(sendData);
                    }
                }   
            }
        }
    }

    const hideModal = () => {
        if (handlerHideModal) handlerHideModal();
        else APP.UI.closeModal();
    }

    const handlerSendFile = data => {
        dispatch(sendMessage(data));
    }

    const handlerFileSend = () => {
        hideModal();
        sendFile();
        dispatch(resetSendFileList());
    }

    return (
        <AbstractDialog name="fileSend" width={450}>
            <ChatPopStyled>
                <div className="guid"> 
                    <p>최대 용량: 15MB </p>
                    <p>전송 가능 파일: jpg, jpeg, gif, bmp, png, mpg, mpeg, mp4, mp3, wav, doc, docx, hwp, txt, pdf, csv, xls, xlsx, ppt, pptx, zip, svg</p>
                </div>
                <br/>
                {
                    [...sendfileList].map(([name, list]) => { 
                        return (
                            <div key={name} className="send_body">
                                <span className="title">{t(`chat.${name}`)}</span>
                                <div className="list">
                                    { list.map((value, index) => {
                                        return (
                                            <p className="chat_list" key={index}>{value.name}</p>    
                                        )                                
                                    })}
                                </div> 
                            </div>
                        );
                    })
                } 

                { sendfileList.has(OK_FILE) && <ClickButton text={t('chat.send')} size={20} onClick={handlerFileSend}/> }
            </ChatPopStyled>
        </AbstractDialog>
    )
}

const ChatPopStyled = styled.div`
    .send_body {
        padding: 4px 12px;

        .title {
            font-size: 13px; font-weight: 700;
        }

        .chat_list {
            padding: 10px;

            &::before {
                content: "-";
                margin: 3px 8px;
                display: inline-block;
            }
        }
    }

    button {
        display: flex;
    }    
`;

function _mapStateToProps(state, ownProps) {
    const sendfileList = ownProps.sendFileList ? ownProps.sendFileList : state['features/chat'].sendFileList;
    const local = getLocalParticipant(state);
    const recipient = ownProps.recipient ? ownProps.recipient : getPrivateMessageRecipient(state);

    return {
        recipient, sendfileList, local
    }
}


export default translate(connect(_mapStateToProps)(SendFileCheckPopup));